import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/common';
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

interface IAuthBackProps {
  className?: string;
}

export const AuthBack: FC<IAuthBackProps> = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Button
      onClick={onBack}
      type={'link'}
      className={classNames(styles.backButton, className)}
      icon={<FontAwesomeIcon icon={faAngleLeft} className={styles.backIcon} />}
    >
      {t('Auth.common.back')}
    </Button>
  );
};

export default AuthBack;
